
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = []
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "c221db96fa893cdd4be6.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			